module.exports = __webpack_public_path__ + "static/media/kelaibo1.e6cffef4.png";